export default "__VITE_ASSET__3e85a5aa__"